
import DeviceList from './deviceModels.json' with {type: 'json'}

export default {
	lookup(manufacturer,modelCode) {
		return DeviceList[`${manufacturer}-${modelCode}`] || modelCode
	},
}
